import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { InjectionToken, isDevMode } from '@angular/core';
import { IRootState, reducersFactory } from './reducers';
import { StoreDevtoolsOptions } from '@ngrx/store-devtools/src/config';
import { RuntimeChecks } from '@ngrx/store/src/models';

export const metaReducers: MetaReducer<IRootState>[] = isDevMode() ? [] : [];

export const ROOT_REDUCER_TOKEN = new InjectionToken<ActionReducerMap<IRootState>>('RootReducers', {
  providedIn: 'root',
  factory: reducersFactory,
});

export const runtimeChecks: Partial<RuntimeChecks> = {
  strictStateImmutability: true,
  strictActionImmutability: true,
  strictStateSerializability: false,
  strictActionWithinNgZone: true,
  strictActionTypeUniqueness: true,
};
export const devToolsOptions: StoreDevtoolsOptions = {
  maxAge: 25,
  logOnly: !isDevMode(),
  autoPause: true,
  trace: true,
  traceLimit: 50,
  connectInZone: true,
};
